export default function FullCTA() {
  return (
    <section className="relative w-full h-[420px] md:h-[500px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20ecommerce%20flat%20lay%20scene%20with%20open%20laptop%20displaying%20colorful%20product%20catalog%20grid%2C%20small%20ceramic%20vase%20with%20dried%20wheat%20stalks%2C%20linen%20notebook%20with%20pen%2C%20warm%20oatmeal%20fabric%20texture%20background%2C%20soft%20natural%20sunlight%20from%20window%2C%20beautiful%20warm%20earthy%20aesthetic%2C%20calm%20inviting%20atmosphere%2C%20editorial%20lifestyle%20photography%20quality%2C%20no%20text%20no%20watermark&width=1600&height=900&seq=full-cta-v3&orientation=landscape"
        alt="Explore KASpreadsheet marketplace"
        title="Explore KASpreadsheet - Complete Spreadsheet System"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 tracking-wide">
          READY TO GET STARTED?
        </h2>
        <p className="text-base md:text-lg text-white/80 font-light mb-8 max-w-xl leading-relaxed">
          Access the full spreadsheet system, browse product categories, and discover automation tools that streamline your sourcing workflow.
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="group inline-flex items-center gap-3 px-8 py-4 bg-foreground-900 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
        >
          <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-full -ml-1">
            <i className="ri-shopping-bag-line text-white text-sm"></i>
          </span>
          EXPLORE KASPREADSHEET.COM
          <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
        </a>
      </div>
    </section>
  );
}